// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__1oHSo"};